define('pagina-resource',['i18n-provider', 'app-route-provider', 'notify-service'], function() {
  var app = angular.module('pagina.resource', ['i18n.provider', 'app.route.provider', 'notify.service']);
  app.factory('Pagina', ['$q', '$http', '$location', 'i18n', 'appRoute', 'notify',
    function($q, $http, $location, i18n, appRoute, notify, $multipart) {
      return {
             getPageContet: function(){
                 return $q(function (resolve, reject) {
                   //  notify.clearNotifications();
                   $http.get($location.absUrl()).success(function (data) {
                             resolve(data);
                         }).error(function (error) {
                         //if (error && error.notifications && !_.isEmpty(error.notifications)) {
                         //    notify.addNotification(error.notifications);
                         //} else {
                         //    notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', i18n.__('imobiliariaLayout')));
                         //}
                         reject(error);
                     });
                 });

             }
      }
    }]);
});
